/** Task expense dynamics report kinds */
export enum TaskExpenseDynamicsKindEnum {
  /** Task expense dynamics report by related counterparty */
  CONTRAGENT = 'CONTRAGENT',
  /** Task expense dynamics report by related direction */
  DIRECTION = 'DIRECTION',
}
